import { CertificateFormDTO } from 'types/contact';
import { request } from 'utils/request';

export const submitCertificateForm = async (
    certificateData: CertificateFormDTO
) => {
    const processedData = {
        ...certificateData,
        participants: certificateData.participants.map((p) => p.participant),
    };
    return await request(
        '/elearning/certificate/hand-hygiene/premium/download',
        { method: 'POST', responseType: 'blob' },
        processedData
    );
};

export const submitCertificateCourseForm = async (coursePath: string) => {
    return await request(`/elearning/certificate/${coursePath}/download`, {
        method: 'GET',
        responseType: 'blob',
    });
};

export const downloadCertificates = async (data: { user_id?: number; user_ids?: number[]; elearning_course_ids: number[] }) => {
    return await request('/admin/certificate/download', {
        method: 'POST',
        responseType: 'blob',
    }, data);
};
export const downloadSingleCertificate = async (coursePath: string) => {
    return await request(`/elearning/certificate/${coursePath}/download`, {
        method: 'GET',
        responseType: 'blob',
    });
};